import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setSessionToken } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;
    if (!session_id) {
      toast.error("Échec de l'authentification Google");
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        await setSessionToken(data.token);
        toast.success("Connecté via Google");
        navigate(data.user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      } catch (err) {
        toast.error("Session invalide");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setSessionToken]);

  return (
    <div className="min-h-[60vh] grid place-items-center">
      <div className="overline text-slate-500">Authentification en cours…</div>
    </div>
  );
}
